import React from 'react';

import { getImageId } from 'src/modules/homeownerApp/types';

import type { UseGeneratedImagePollingParams } from '../hooks';
import { useGeneratedImagePolling } from '../hooks';

interface PollImageProps extends UseGeneratedImagePollingParams {}

const PollImage = (props: PollImageProps) => {
  useGeneratedImagePolling(props);

  return null;
};

export interface PollGeneratedImageProps extends Omit<PollImageProps, 'image'> {
  image: PollImageProps['image'] | undefined | null;
}

/**
 * Poll a generated image for its status using `useGeneratedImagePolling`. If no
 * `image` is passed, this component does nothing. This allows us to use the
 * `useGeneratedImagePolling` hook conditionally since it requires an image.
 *
 * @param props props to pass to `useGeneratedImagePolling`
 */
export const PollGeneratedImage = ({
  image,
  ...props
}: PollGeneratedImageProps) => {
  if (image) {
    // Providing a key ensures we dismount the previous PollImage and mount the
    // new PollImage if the passed in image changes. This in turn ensures that
    // polling stops for the dismounted image. Without this key, there are edge
    // cases where polling continues indefinitely
    return <PollImage image={image} key={getImageId(image)} {...props} />;
  }

  return null;
};
